import { othersRouter } from './othersRouter'
import { activeRouter } from './activeRouter'
import { rulesRouter } from './rulesRouter'
import { loginRouter } from './loginRouter'
import { productRouter } from './productRouter'
import { saleCalendarRouter } from './saleCalendarRouter'
import { couponRouter } from './couponRouter'
import { articleRouter } from './articleRouter'
import { videoRouter } from './videoRouter'
import { merchantRouter } from './merchantRouter'
import { myRouter } from './myRouter'
import { cardExtractorRouter } from './cardExtractor'
import { c2cRouter } from './c2cRouter'
import { ipRouter } from './ipRouter'
import { ipMachineRouter } from './ipMachineRouter'
import { ipMachineActiveRouter } from './ipMachineActiveRouter'
import { uBoxMachineRouter } from './uBoxMachineRouter'
import { homeRouter } from './homeRouter'
import { universeBoxRouter } from './universeBox'
import { orderRouter } from './orderRouter'
import { rechargeRouter } from './rechargeRouter'
import { breakingRouter } from './breakingRouter'
import { pointRouter } from './pointRouter'

//
const routes = [
  ...homeRouter,
  ...othersRouter,
  // ...activeRouter,
  // ...rulesRouter,
  ...loginRouter,
  // ...productRouter,
  // ...saleCalendarRouter,
  // ...couponRouter,
  // ...articleRouter,
  ...uBoxMachineRouter,
  // ...videoRouter,
  // ...merchantRouter,
  ...myRouter,
  ...universeBoxRouter,
  ...orderRouter,
  ...rechargeRouter,
  ...breakingRouter,
  ...pointRouter,
  // ...cardExtractorRouter,
  // ...c2cRouter,
  // ...ipRouter,
  // ...ipMachineRouter,
  // ...ipMachineActiveRouter,
]

export default routes